import React from 'react';
import { Instagram, Linkedin, Twitter, ExternalLink } from 'lucide-react';

const TiktokIcon = ({ className }: { className?: string }) => (
  <svg
    viewBox="0 0 24 24"
    fill="currentColor"
    className={className}
    aria-hidden="true"
  >
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
  </svg>
);

export const socialLinks = [
  {
    name: 'Instagram',
    icon: Instagram,
    url: 'https://www.instagram.com/wearelumilabs',
    handle: '@wearelumilabs'
  },
  {
    name: 'TikTok',
    icon: TiktokIcon,
    url: 'https://www.tiktok.com/@wearelumilabs',
    handle: '@wearelumilabs'
  },
  {
    name: 'X (Twitter)',
    icon: Twitter,
    url: 'https://x.com/wearelumilabs',
    handle: '@wearelumilabs'
  },
  {
    name: 'LinkedIn',
    icon: Linkedin,
    url: 'https://www.linkedin.com/company/wearelumilabs/',
    handle: 'Lumi Labs'
  },
  {
    name: 'Bluesky',
    icon: ExternalLink,
    url: 'https://bsky.app/profile/lumilabs.bsky.social',
    handle: '@lumilabs.bsky.social'
  }
];

interface SocialLinksProps {
  className?: string;
  iconClassName?: string;
  showLabels?: boolean;
  column?: boolean;
}

const SocialLinks: React.FC<SocialLinksProps> = ({ 
  className = "", 
  iconClassName = "w-8 h-8",
  showLabels = false,
  column = false 
}) => {
  return (
    <div className={`flex ${column ? 'flex-col space-y-3' : 'space-x-6'} ${className}`}>
      {socialLinks.map((social) => (
        <a
          key={social.name}
          href={social.url}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center text-gray-600 hover:text-cyan-600 transition-colors"
          aria-label={`Visit our ${social.name} profile`}
        >
          <social.icon className={iconClassName} />
          {showLabels && <span className="ml-2 text-lg">{social.handle}</span>}
        </a>
      ))}
    </div>
  );
};

export default SocialLinks;